module Bookhus {
    export class Dealswidget {
        private parameters: IDealswidgetParameters;
        private dataService: IDealsDataService;
        private type: number;
        private localizedStrings = {
            flereTilbud: {
                "da": "Se flere tilbud",
                "en-GB": "See more deals",
                "de": "Mehr angebote",
                "sv": "Se fler erbjudanden",
                "no": "Se flere tilbud"
            },
            flereAfbud: {
                "da": "Se flere afbud",
                "en-GB": "See more cancellations",
                "de": "Mehr stornierungen",
                "sv": "Se fler avbokningar",
                "no": "Se flere avbestillinger"
            },
            flere: {
                "da": "Se flere",
                "en-GB": "See more",
                "de": "Mehr",
                "sv": "Se fler",
                "no": "Se flere"
            },
            tilbud: {
                "da": "Tilbud",
                "en-GB": "Deal",
                "de": "Angebote",
                "sv": "Anbud",
                "no": "Tilbud"
            },
            afbud: {
                "da": "Afbud",
                "en-GB": "Cancellation",
                "de": "Abgesagt",
                "sv": " Återbud",
                "no": "Avbestillinger"
            },
            book: {
                "da": "Book",
                "en-GB": "Book",
                "de": "Buch",
                "sv": " Bok",
                "no": "Bok"
            },
            info: {
                "da": "Info",
                "en-GB": "Info",
                "de": "Info",
                "sv": " Info",
                "no": "Info"
            },
            standardpris: {
                "da": "Standardpris",
                "en-GB": "Standard price",
                "de": "Einheitspreis",
                "sv": "Standardpris",
                "no": "Standard pris"
            },
            fra: {
                "da": "Fra",
                "en-GB": "From",
                "de": "Von",
                "sv": "Från",
                "no": "Fra"
            },
            til: {
                "da": "Til",
                "en-GB": "To",
                "de": "Zu",
                "sv": "Till",
                "no": "Til"
            },
            bookperiodtext: {
                "da": "Book en [PERIOD] i perioden",
                "en-GB": "Book a [PERIOD] during the period",
                "de": "Buchen Sie einen [PERIOD] während des Zeitraums",
                "sv": "Boka en [PERIOD] under perioden",
                "no": "Bestill en [PERIOD] i perioden"
            }
        }
        constructor(parameters: IDealswidgetParameters) {
            this.parameters = parameters;

            switch (parameters.type) {
                case "tilfældig":
                    this.type = 3;
                    this.startCarrousel();
                    break;
                case "fremhævet":
                    this.type = 2;
                   // console.log("Type Fremhævet is not implemented.");
                    this.drawBackup();
                    break;
                case "afbud":
                    this.type = 1;
                    this.startCarrousel();
                    break;
                case "tilbud":
                    this.type = 0;
                    this.startCarrousel();
                    break;
                case "ingen":
                    this.drawBackup();
                    break;
                default:
                   // console.log(`Type ${parameters.type} is not recognized.`);
                    this.drawBackup();
                    break;
            }

        }

        private startCarrousel(): void {
            this.dataService = new DealsDataservice();
            this.loadAndRedraw(1);
        }

        private loadAndRedraw(pagenumber: number) {
            var type = this.type;
            //if (this.dataService.deal != null) {
            //    type = this.dataService.deal.type;
            //}

            var xhr = this.dataService.loadDataAjax(pagenumber, type);
            xhr.always(() => {
                this.draw();
            });
        }

        private draw() {
            if (this.dataService.deal == undefined) {
                //console.log("DealsDataService.deal was undefined.");
                this.drawBackup();
                return;
            }

            var protocol = (window.location.protocol || "http:") + '//';
            var url = "";
            if (this.dataService.deal.house.domain != null && this.dataService.deal.house.domain.length > 0) {
                url = protocol + this.dataService.deal.house.domain;
            }
            
            var infolink = `${url}/house/${this.dataService.deal.house.id}`;
            var merelink = ``;
            var meretekst = this.localizedStrings.flere[this.parameters.culture];

            var fromdate = new Date(this.dataService.deal.fromdateRfc1123);
            var fromtime = fromdate.toString("HH:mm");

            var todate = new Date(this.dataService.deal.todateRfc1123);
            var totime = todate.toString("HH:mm");

            var pricestring = `${this.localizedStrings.standardpris[this.parameters.culture]}: <strong>${this.dataService.deal.priceString}</strong>`;

            var bookinglink = `${url}/book/${this.dataService.deal.house.id}?date=${fromdate.formatDate("dd-mm-yy") }`;

            var selectedHouseattributes = this.dataService.deal.selectedAttributes;
            
            var fromandtodateString = `${this.localizedStrings.fra[this.parameters.culture]} ${fromdate.formatDate("dd-mm-yy")} ${fromtime} ${this.localizedStrings.til[this.parameters.culture].toLowerCase()} ${todate.formatDate("dd-mm-yy") } ${totime}`;
            var bookDealType = "";
            var dealname = "";
            var dealtypeclass = "";
            if (this.dataService.deal.type === 0) {
                dealtypeclass = "";
                dealname = this.parameters.title || this.localizedStrings.tilbud[this.parameters.culture];
                bookDealType = this.localizedStrings.bookperiodtext[this.parameters.culture]
                    .replace('[PERIOD]', this.dataService.deal.bookDescription) + '<br/>';
                meretekst = this.localizedStrings.flereTilbud[this.parameters.culture];
                pricestring = `Spar <strong>${this.dataService.deal.priceString}</strong>`;
                bookinglink = `${url}/book/${this.dataService.deal.house.id}`;
                fromandtodateString = `${this.localizedStrings.fra[this.parameters.culture]} ${fromdate.formatDate("dd-mm-yy")} ${this.localizedStrings.til[this.parameters.culture].toLowerCase()} ${todate.formatDate("dd-mm-yy") }`;
                merelink = `/booking/tilbudlist`;
            } else if (this.dataService.deal.type === 1) {
                dealtypeclass = "deal-type-cancellation";
                dealname = this.parameters.title || this.localizedStrings.afbud[this.parameters.culture];
                merelink = `/booking/cancellationlist`;
                meretekst = this.localizedStrings.flereAfbud[this.parameters.culture];
                fromandtodateString = `${this.localizedStrings.fra[this.parameters.culture]} ${fromdate.formatDate("dd-mm-yy")} ${this.localizedStrings.til[this.parameters.culture].toLowerCase()} ${todate.formatDate("dd-mm-yy")}`;
                if (this.dataService.deal.showPrice === false) pricestring = "";
            } else {
                totime = "";
                fromtime = "";
                pricestring = "";
                merelink = `/catalog`;
                fromandtodateString = "";
            }

            var dealTypeTab = dealname === "" ? "" : `<div class="deal-type ${dealtypeclass}">${dealname}</div>`;
            var template = "";

            var deal: any = this.dataService.deal;

            if (this.dataService.deal.house.id <= 0 && this.dataService.deal.type === 0) {
                template = `<article class="deal brand-background">	                    
	                    ${dealTypeTab}
                
	                    <div class="deal-info">
                            <br />
		                    <p>
                                ${bookDealType}
                                ${fromandtodateString}<br />
			                    ${selectedHouseattributes}
		                    </p>
	                    </div>
	                    <div class="deal-buttons-all">
                            <p>${pricestring}</p>                            
		                    <a href="${merelink}" class="btn more-deals">» ${meretekst}</a>
	                    </div>
	                    <div id="${this.parameters.containerId}_back" class="nav-arrow nav-arrow-left"></div>
	                    <div id="${this.parameters.containerId}_forward" class="nav-arrow nav-arrow-right"></div>                        
                    </article>`;
            } else {
                template = `<article class="deal brand-background">
	                    <div class="deal-photo" style="background-image: url(${url}/Houseimage/${this.dataService.deal.house.imageId}/280)"></div>
	                    ${dealTypeTab}
                
	                    <div class="deal-info">
                                   ${this.dataService.deal.house.title}
		                    <p>
                                ${bookDealType}
                                ${fromandtodateString}<br />
			                    ${selectedHouseattributes}
		                    </p>
	                    </div>
	                    <div class="deal-buttons">
                            <p>${pricestring}</p>
                            <a href="${bookinglink}" class="btn btn-default" aria-label="Book ${this.dataService.deal.bookDescription} ${fromandtodateString}" data-bookhusportal="${(deal.house.domain.length > 0 ? "show" : "")}" data-propertyowner="${deal.house.companyName}" data-encrypteddata="${deal.house.encryptedData}" data-redirectto="/book/${deal.house.id}">
                                ${this.localizedStrings.book[this.parameters.culture]}
                            </a>
		                    <a href="${infolink}" class="btn btn-default" aria-label="Vis information om ${this.dataService.deal.bookDescription}" data-bookhusportal="${(deal.house.domain.length > 0 ? "show" : "")}" data-propertyowner="${deal.house.companyName}" data-encrypteddata="${deal.house.encryptedData}" data-redirectto="/house/${deal.house.id}">
                                Info
                            </a>
		                    <a href="${merelink}" class="btn more-deals">» ${meretekst}</a>
	                    </div>
	                    <div id="${this.parameters.containerId}_back" class="nav-arrow nav-arrow-left"></div>
	                    <div id="${this.parameters.containerId}_forward" class="nav-arrow nav-arrow-right"></div>
                        <div class="gallery-copyright">${this.dataService.deal.house.imageCopyright}</div>
                    </article>`;
            }
            
            var element = $("#" + this.parameters.containerId);
            if (element.children().length > 0) {
                $(element.children()).fadeOut().remove();
                //element.fadeOut();
            }

            element.append($(template).hide().fadeIn());
            $(`#${this.parameters.containerId}_back`).click(() => {
                this.loadAndRedraw(this.dataService.deal.pagenumber - 1);
            });

            $(`#${this.parameters.containerId}_forward`).click(() => {
                this.loadAndRedraw(this.dataService.deal.pagenumber + 1);
            });
        }

//        private drawEmpty() {
//            var template = `
//<article class="deal brand-background">
//	<div class="deal-photo" style="background-image: url(/Houseimage/0)"></div>
//	<div class="deal-type deal-type-empty">Ingen</div>
//	<div class="deal-info">
//		<h1>Ingen forekomster i øjeblikket</h1>
//		<p>
//		</p>
//	</div>
//	<div class="deal-buttons">

//	</div>
//	<div id="${this.parameters.containerId}_back" class="nav-arrow nav-arrow-left"></div>
//	<div id="${this.parameters.containerId}_forward" class="nav-arrow nav-arrow-right"></div>
//</article>
//`;
//            var element = $(`#${this.parameters.containerId}`);
//            if (element.children().length > 0) {
//                $(element.children()).fadeOut().remove();
//                //element.fadeOut();
//            }
//            element.append($(template).hide().fadeIn());
//        }

        private drawBackup(): void {
            var content = `<a href="${this.parameters.backupDestination}"><div class="teaser-banner" style="background-Image:url(${this.parameters.backupImage})"><div class="teaser-banner-text brand-background">${this.parameters.backupText}</div></div></a>`;
            $(`#${this.parameters.containerId}`).replaceWith(content);
        }

    }
}